import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {useKeycloak} from '@react-keycloak/web';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {Button, Table} from 'antd';
import CertificateInfo from './CertificateInfo';
import {findOrganizationById} from 'services/OrganizationService';

const CertificateList = (props) => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();
  const navigate = useNavigate();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const {practitioner} = props;
  const [certificates, setCertificates] = useState();
  const [selectedCertificate, setSelectedCertificate] = useState();
  const [viewing, setViewing] = useState(false);

  useEffect(() => {
    if (practitioner?.certificates) {
      Promise.all(
        _.uniqBy(
          practitioner?.certificates.map((cert) => cert.issuer),
          function (e) {
            return e.id;
          },
        ).map((issuer) => {
          return findOrganizationById(headers, issuer.id).then(
            (res) => res.data,
          );
        }),
      ).then((values) => {
        const _certificates = practitioner.certificates.map((cert) => {
          const _issuer = {...cert.issuer};
          _issuer.name = values.find((org) => org.id === cert.issuer?.id)?.name;
          cert.issuer = {..._issuer};

          return cert;
        });

        setCertificates(_certificates);
      });
    }
  }, [practitioner]);

  const onView = (certificate) => {
    setSelectedCertificate(certificate);
    setViewing(true);
  };

  const columns = [
    {
      title: intl.messages['practitioner.certificate.certNumber'],
      dataIndex: 'certNumber',
      key: 'certNumber',
      render: (certNumber, record) => (
        <Button type='link' onClick={() => onView(record)}>
          {certNumber}
        </Button>
      ),
    },
    {
      title: intl.messages['practitioner.certificate.name'],
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: intl.messages['practitioner.certificate.startTime'],
      dataIndex: 'period',
      key: 'period',
      render: (period) => <span>{period?.start}</span>,
    },
    {
      title: intl.messages['practitioner.certificate.endTime'],
      dataIndex: 'period',
      key: 'period',
      render: (period) => <span>{period?.end}</span>,
    },
    {
      title: intl.messages['practitioner.certificate.issuer'],
      dataIndex: 'issuer',
      key: 'issuer',
      render: (issuer) => (
        <Button
          type='link'
          onClick={() => navigate(`/health/organizations/${issuer.id}`)}>
          {issuer?.name}
        </Button>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={certificates}
        rowKey={(record) => record.certNumber}
        pagination={false}
        scroll={{x: 'auto'}}
      />

      <CertificateInfo
        selectedCertificate={selectedCertificate}
        viewing={viewing}
        setViewing={setViewing}
      />
    </>
  );
};

export default CertificateList;

CertificateList.propTypes = {
  practitioner: PropTypes.object,
};
